"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.csvParse = void 0;
const papaparse_1 = require("papaparse");
/**
 * Parse CSV file
 *
 * input type:
 * input CSV string / file / NodeJS.ReadableStream
 * maxValuesInValueSet maximum number of values in value-set. Default: 50
 * removeValueSetIfExceedsValueLimit if there are more values then the maxValuesInValueSet: false- include the first values until reaching the limit, true- delete value-set. (default: false)
 * previewRows number of rows to preview. Default: all
 * skipValueSets whether to skip parsing of value-sets (for better performance)
 * extractColumnsTypes whether to identify column-types (default: false, for better performance)
 * onRowCallback a callback that runs per parsed row
 *
 * @returns Promise<CsvParseResult> which resolved to an object with header, csvData, valueSets, columnsTypes
 */
const csvParse = async ({ input, maxValuesInValueSet, removeValueSetIfExceedsValueLimit, previewRows, skipValueSets, extractColumnsTypes, onRowCallback }) => {
    return new Promise((resolve, reject) => {
        let tempHeader;
        let tempCsvData = [];
        let tempValueSet;
        let tempColumnsTypes;
        let rowsCount = 0;
        let startTime = Date.now();
        (0, papaparse_1.parse)(input, {
            // header: true, // to work with arrays
            delimiter: ",",
            step: (results) => {
                var _a, _b, _c;
                if (!tempHeader) {
                    // Collect header
                    tempHeader = results.data;
                    // Init value-sets
                    if (!skipValueSets) {
                        tempValueSet = results.data.reduce((acc, cur) => {
                            acc[cur] = new Set();
                            return acc;
                        }, {});
                    }
                    // Init columns-types
                    if (extractColumnsTypes) {
                        tempColumnsTypes = results.data.reduce((acc, cur) => {
                            acc[cur] = null;
                            return acc;
                        }, {});
                    }
                }
                else {
                    rowsCount++;
                    // Collect data (default is to collect all rows)
                    if (previewRows === undefined || previewRows === null || tempCsvData.length < previewRows) {
                        tempCsvData.push(results.data);
                    }
                    if (!skipValueSets || extractColumnsTypes) {
                        for (let i = 0; i < tempHeader.length; i++) {
                            // Collect value-sets
                            if (!skipValueSets && results.data[i] !== null && results.data[i] !== undefined && results.data[i] !== "") {
                                (_a = tempValueSet[tempHeader[i]]) === null || _a === void 0 ? void 0 : _a.add(results.data[i]);
                                // Check if max values exceeded
                                if (((_b = tempValueSet[tempHeader[i]]) === null || _b === void 0 ? void 0 : _b.size) > (maxValuesInValueSet !== null && maxValuesInValueSet !== void 0 ? maxValuesInValueSet : 50)) {
                                    if (removeValueSetIfExceedsValueLimit) {
                                        delete tempValueSet[tempHeader[i]];
                                    }
                                    else {
                                        (_c = tempValueSet[tempHeader[i]]) === null || _c === void 0 ? void 0 : _c.delete(results.data[i]);
                                    }
                                }
                            }
                            // Collect columns-types
                            if (extractColumnsTypes) {
                                for (let i = 0; i < tempHeader.length; i++) {
                                    // Check column only if not already "string"
                                    const currentColumnType = tempColumnsTypes[tempHeader[i]];
                                    const currentValue = results.data[i];
                                    if (currentColumnType !== "string") {
                                        if ((currentColumnType === null || currentColumnType === "boolean") &&
                                            (currentValue === true || currentValue == false || currentValue === "true" || currentValue === "false")) {
                                            tempColumnsTypes[tempHeader[i]] = "boolean";
                                        }
                                        else if ((currentColumnType === null || currentColumnType === "number") && !Number.isNaN(Number(currentValue))) {
                                            tempColumnsTypes[tempHeader[i]] = "number";
                                        }
                                        else {
                                            tempColumnsTypes[tempHeader[i]] = "string";
                                        }
                                    }
                                }
                            }
                        }
                    }
                    if (typeof onRowCallback === "function") {
                        onRowCallback({ header: tempHeader, row: results.data });
                    }
                }
            },
            dynamicTyping: false,
            complete: () => {
                resolve({
                    header: tempHeader,
                    columnsTypes: tempColumnsTypes,
                    csvData: tempCsvData,
                    valueSets: tempValueSet,
                    totalRows: rowsCount,
                    parseDuration: Date.now() - startTime
                });
            },
            error: (error) => {
                reject(error);
            }
        });
    });
};
exports.csvParse = csvParse;
//# sourceMappingURL=csvParser.js.map